import React from 'react';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SelectApi from '../../common/SelectApi';
import { WidgetInOutProductProps } from '../Dashboard.types';

interface InOutProductFiltersProps {
 control: Control<WidgetInOutProductProps>;
 setValue: UseFormSetValue<WidgetInOutProductProps>;
 errors: FieldErrors<WidgetInOutProductProps>;
}

const InOutProductFilters: React.FC<InOutProductFiltersProps> = ({
 control,
 setValue,
 errors,
}) => {
 const { t } = useTranslation();
 const productFilter = JSON.stringify({ fields: 'Id,Name' });
 const destPointFilter = JSON.stringify({ fields: 'Id,Name' });
 return (
  <>
   <SelectApi<WidgetInOutProductProps>
    name="products"
    url="/api/Products/v2/"
    filter={productFilter}
    label={t('dashboard.filters.product')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetInOutProductProps>
    name="productGroups"
    url="/api/Products/v2/groups"
    filter={productFilter}
    label={t('dashboard.filters.productGroups')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetInOutProductProps>
    name="toDestPoint"
    url="/api/DestPoint/v1/"
    filter={destPointFilter}
    label={t('dashboard.filters.toDestPointLabel')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetInOutProductProps>
    name="destPointGroup"
    url="/api/DestPoint/v1/groups"
    filter={destPointFilter}
    label={t('dashboard.filters.destPointGroups')}
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
  </>
 );
};

export default InOutProductFilters;
